// extracted by mini-css-extract-plugin
export default {"importPanel":"nuevoEmpleado_importPanel__uAk7c","importOptions":"nuevoEmpleado_importOptions__kNcHT","fileInput":"nuevoEmpleado_fileInput__n7AlB"};